import { render, staticRenderFns } from "./ThreeDSCompleteSetupPage.vue?vue&type=template&id=304dbcdb&"
import script from "./ThreeDSCompleteSetupPage.vue?vue&type=script&lang=js&"
export * from "./ThreeDSCompleteSetupPage.vue?vue&type=script&lang=js&"
import style0 from "./ThreeDSCompleteSetupPage.vue?vue&type=style&index=0&id=304dbcdb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports